module.exports = {"data":{"contentfulIntegration":{"name":"Magento","slug":"magento","id":"c51Nc5zTYTKc4Ug0Yuouq4w","website":"https://magento.com","product":null}},"pathContext":{"slug":"magento"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/integration-magento.json
// module id = 1318
// module chunks = 181568259120545